(function () {
  function clampStep(value, min, max, step) {
    var v = Number(value || 0);
    if (isNaN(v)) v = min;
    v = Math.max(min, Math.min(max, v));
    // round to nearest step
    v = Math.round(v / step) * step;
    // ensure still within bounds after rounding
    v = Math.max(min, Math.min(max, v));
    return v;
  }

  function formatCents(cents) {
    // Prefer Shopify formatter if available
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.Shopify.currency) {
      return Shopify.formatMoney(cents, window.Shopify.currency.active || '{{ shop.money_format }}');
    }
    // Fallback EU style: € 1.234,00
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2);
    }
  }

  function findClosestVariant(variants, targetCents) {
    if (!variants || !variants.length) return null;
    // Prefer available variants
    var pool = variants.filter(function (v) { return !!v.available; });
    if (!pool.length) pool = variants.slice(0);

    var best = pool[0];
    var bestDelta = Math.abs(pool[0].price - targetCents);

    for (var i = 1; i < pool.length; i++) {
      var v = pool[i];
      var d = Math.abs(v.price - targetCents);
      if (d < bestDelta || (d === bestDelta && v.price < best.price)) {
        best = v; bestDelta = d;
      }
    }
    return best;
  }

  function initForContainer(container) {
    var section = container.closest('[data-section-type="product"]');
    if (!section) return;

    var input = container.querySelector('[data-custom-amount-input]');
    var propInput = container.querySelector('[data-custom-amount-prop]');
    if (!input || !propInput) return;

    // Hidden variant input that the form submits
    var hiddenVariantInput = section.querySelector('input[name="id"]');
    if (!hiddenVariantInput) return;

    // Product JSON
    var productScript = section.querySelector('script[data-product-json]');
    if (!productScript) return;

    var product;
    try { product = JSON.parse(productScript.textContent); } catch (e) { return; }
    var variants = product && product.variants ? product.variants : [];
    if (!variants.length) return;

    function applyAmount(rawValue) {
      var amount = clampStep(rawValue, 100, 10000, 50); // €100–€10,000 in €50 steps
      input.value = amount;
      propInput.value = String(amount);

      var targetCents = Math.round(amount * 100);
      var match = findClosestVariant(variants, targetCents);
      if (match) {
        // Update hidden variant id so the correct variant is added to cart
        hiddenVariantInput.value = match.id;

        // Update the visible price (simple case)
        var priceHolder = section.querySelector('[data-product-price]');
        if (priceHolder) {
          // If your theme injects complex HTML here, you may prefer dispatching a change event instead.
          priceHolder.textContent = formatCents(match.price);
        }
      }
    }

    // Init on load
    applyAmount(input.value || 100);

    // Events
    input.addEventListener('change', function (e) { applyAmount(e.target.value); });
    input.addEventListener('blur', function (e) { applyAmount(e.target.value); });

    // If the theme changes variants elsewhere, keep our hidden property in sync
    document.addEventListener('variant:change', function () {
      // Re-apply to refresh price/variant if needed
      applyAmount(input.value || 100);
    });
  }

  function init() {
    document.querySelectorAll('[data-custom-amount-container]').forEach(initForContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.Product__CustomAmount')) {
    document.body.classList.add('has-custom-amount');
  }
});